if (!customElements.get('quantity-popover')) {
    customElements.define(
        'quantity-popover',
        class QuantityPopover extends HTMLElement {
            constructor() {
                super();
                this.mql = window.matchMedia('(min-width: 990px)');
                this.mqlTablet = window.matchMedia('(min-width: 750px)');
                this.infoButtonDesktop = this.querySelector('.quantity-popover__info-button--icon-only');
                this.infoButtonMobile = this.querySelector('.quantity-popover__info-button--icon-with-label');
                this.popoverInfo = this.querySelector('.quantity-popover__info');
                this.closeButton = this.querySelector('.button-close');
                this.variantInfo = this.querySelector('.quantity-popover-container');
                this.eventMouseEnterHappened = false;
                var plusButtonsOld = document.querySelectorAll('[name="plus"]');

                if (this.closeButton) {
                    this.closeButton.addEventListener('click', this.closePopover.bind(this));
                }

                if (this.popoverInfo && this.infoButtonDesktop && this.mql.matches) {
                    this.popoverInfo.addEventListener('mouseenter', this.closePopover.bind(this));
                }

                if (this.infoButtonDesktop) {
                    this.infoButtonDesktop.addEventListener('click', this.togglePopover.bind(this));
                    this.infoButtonDesktop.addEventListener('focusout', this.closePopover.bind(this));
                }

                if (this.infoButtonMobile) {
                    this.infoButtonMobile.addEventListener('click', this.togglePopover.bind(this));
                    this.infoButtonMobile.addEventListener('focusout', this.closePopover.bind(this));
                }

                if (this.infoButtonDesktop && this.mqlTablet.matches) {
                    this.variantInfo.addEventListener('mouseenter', this.togglePopover.bind(this));
                    this.variantInfo.addEventListener('mouseleave', this.closePopover.bind(this));
                }

                if (plusButtonsOld) {
                    plusButtonsOld.forEach(plusButtonOld => {
                        if (!plusButtonOld.classList.contains('custom-plus-button-added')) {
                            console.log("Button Found and Hidden");
                            plusButtonOld.classList.add('custom-plus-button-added');
                            plusButtonOld.style.display = 'none';

                            var customButton = document.createElement('button');
                            customButton.className = 'custom-plus-button quantity__button no-js-hidden';
                            customButton.addEventListener('click', this.redirectToProductPage.bind(this));

                            var svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                            svgElement.setAttribute("xmlns", "http://www.w3.org/2000/svg");
                            svgElement.setAttribute("aria-hidden", "true");
                            svgElement.setAttribute("focusable", "false");
                            svgElement.setAttribute("class", "icon icon-plus");
                            svgElement.setAttribute("fill", "none");
                            svgElement.setAttribute("viewBox", "0 0 10 10");

                            var pathElement = document.createElementNS("http://www.w3.org/2000/svg", "path");
                            pathElement.setAttribute("fill-rule", "evenodd");
                            pathElement.setAttribute("clip-rule", "evenodd");
                            pathElement.setAttribute("d", "M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z");
                            pathElement.setAttribute("fill", "currentColor");

                            svgElement.appendChild(pathElement);
                            customButton.appendChild(svgElement);
                            plusButtonOld.parentNode.insertBefore(customButton, plusButtonOld.nextSibling);
                        }
                    });
                }
            }

            redirectToProductPage(event) {
                event.preventDefault();
                event.stopPropagation();
                console.log("Increasing the Quantity...");
                var closestTr = this.closest("tr.cart-item");
                var itemNameLink = closestTr.querySelector("a.cart-item__name");
                var final_redirect_href = itemNameLink.getAttribute("href");
                window.location.href = final_redirect_href;
            }

            togglePopover(event) {
                if (event.type === 'mouseenter') {
                    this.eventMouseEnterHappened = true;
                }

                if (event.type === 'click' && this.eventMouseEnterHappened) return;

                const button = this.infoButtonDesktop && this.mql.matches ? this.infoButtonDesktop : this.infoButtonMobile;
                const isExpanded = button.getAttribute('aria-expanded') === 'true';

                button.setAttribute('aria-expanded', !isExpanded);

                this.popoverInfo.toggleAttribute('hidden');

                const isOpen = button.getAttribute('aria-expanded') === 'true';

                button.classList.toggle('quantity-popover__info-button--open');

                if (isOpen && event.type !== 'mouseenter') {
                    button.focus();
                }
            }

            closePopover(event) {
                event.preventDefault();
                const isChild = this.variantInfo.contains(event.relatedTarget);
                const button = this.infoButtonDesktop && this.mql.matches ? this.infoButtonDesktop : this.infoButtonMobile;

                if (!event.relatedTarget || !isChild) {
                    button.setAttribute('aria-expanded', 'false');
                    button.classList.remove('quantity-popover__info-button--open');
                    this.popoverInfo.setAttribute('hidden', '');
                }

                this.eventMouseEnterHappened = false;
            }
        }
    );
}
